// src/utils/queryUtils.ts
export const getQueryParam = (param: string): string | null => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(param);
};

export const getAllQueryParams = (): { [key: string]: string | null } => {
  const searchParams = new URLSearchParams(window.location.search);
  const params: { [key: string]: string | null } = {};
  searchParams.forEach((value, key) => {
    params[key] = value;
  });
  return params;
};
